import ClientsAxios from '../../client-axios';
import { ResponseEntity } from '../../dto/response';

const { API_SERVER } = ClientsAxios;


export const FetchWorkflowMasterList = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('workflows/listing', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchModuleListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('workflows/module-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const FetchEmployeeListService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('workflows/get-user-list', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const storeWorkflowMasterService = async (payload: any, isUpdate: boolean = false) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const urlType = isUpdate ? 'update' : 'create';
        const response = await API_SERVER.post(`workflows/${urlType}`, payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}

export const getWorkFlowDetailsService = async (payload: any) => {
    const responseEntity = new ResponseEntity<any>()
    try {
        const response = await API_SERVER.post('workflows/details', payload)
        responseEntity.success(response.data.body, 200, response.data.message)
    } catch (error: any) {
        const response = error.response || {};
        responseEntity.error(response?.StatusCode || 500, error?.message, response?.data?.body || {})
    }
    return responseEntity
}